import React from 'react';
import SideContainerComponent from '../SideContainer.component';
import { MainContentContainer, MainSection } from '../OtherPages.styles';
import HelmetHelper from '../../Components/PageHelmet/HelmetHelper.component';
import PageHeader from '../../Components/PageHeader/PageHeader.component';
import Breadcrumbs from '../../Components/Breadcrumbs/BreadcrumbsComponent.component';
import {
  FaClock,
  FaEnvelope,
  FaMapMarkerAlt,
  FaPhoneAlt,
  FaExternalLinkAlt,
} from 'react-icons/fa';

import {
  ContactInfoSection,
  ContactOverview,
  OverviewContent,
  // OverviewIcon,
  OverviewLabel,
  OverviewTitle,
  OverviewDetails,
  OverviewDetail,
  OverviewDetailIcon,
  ContactCardsGrid,
  ContactCard,
  ContactCardHeader,
  ContactAvatar,
  ContactHeaderContent,
  ContactHeader,
  ContactRole,
  ContactDetails,
  ContactDetail,
  ContactDetailIcon,
  ContactDetailContent,
  ContactDetailLabel,
  ContactLink,
} from './ContactUs.styles';

const ContactUs = () => {
  const contactInfo = [
    {
      name: 'Jim Benoit',
      role: 'President/CEO ASA/CSO/Auditor/Trainer/Site Inspector/Health & Safety Program and Course Development',
      email: 'jbenoit.yoda@outlook.com',
      phone: '902-478-1972',
    },
    {
      name: 'Helen Benoit',
      role: 'Office Admin, CSO/IAC/CDA',
      email: 'hbenoit.yoda@outlook.com',
      phone: '902-802-9716',
    },
    {
      name: 'Victoria Benoit',
      role: 'VRB Web Design & Development',
      email: 'victoria@vrbwebdesignanddev.com',
      phone: '902-817-1001',
      portfolio: 'https://vrbwebdesignanddev.com',
    },
  ];

  return (
    <MainContentContainer>
      <HelmetHelper
        title="Contact Us"
        description="Contact Yoda Safety Services for workplace safety support, training inquiries, and product information."
      />

      <SideContainerComponent />

      <MainSection>
        <Breadcrumbs one="Home" oneLink="/" two="Contact Us" />
        <PageHeader
          eyebrow="Contact"
          title="Get in Touch with Yoda Safety Services"
          desc="Have a question about training, safety services, or workplace products? Reach out to our team and we will help point you in the right direction."
        />

        <ContactInfoSection>
          <ContactOverview>
            <OverviewContent>
              {/* <OverviewIcon aria-hidden="true">
                <FaMapMarkerAlt />
              </OverviewIcon> */}

              <div>
                <OverviewLabel>Our Location</OverviewLabel>

                <OverviewTitle>Visit or Contact Our Team</OverviewTitle>

                <OverviewDetails>
                  <OverviewDetail>
                    <OverviewDetailIcon aria-hidden="true">
                      <FaMapMarkerAlt />
                    </OverviewDetailIcon>

                    <address>
                      825 Ostrea Lake Road, Ostrea Lake NS B0J 2L0, Canada
                    </address>
                  </OverviewDetail>

                  <OverviewDetail>
                    <OverviewDetailIcon aria-hidden="true">
                      <FaClock />
                    </OverviewDetailIcon>

                    <span>
                      Monday to Friday
                      <strong>9:00 AM to 5:00 PM</strong>
                    </span>
                  </OverviewDetail>
                </OverviewDetails>
              </div>
            </OverviewContent>
          </ContactOverview>

          <ContactCardsGrid>
            {contactInfo.map((contact) => {
              const email = contact.email?.toLowerCase();

              return (
                <ContactCard key={contact.email || contact.name}>
                  <ContactCardHeader>
                    <ContactAvatar aria-hidden="true">
                      {contact.name?.charAt(0).toUpperCase()}
                    </ContactAvatar>

                    <ContactHeaderContent>
                      <ContactHeader>{contact.name}</ContactHeader>
                      <ContactRole>{contact.role}</ContactRole>
                    </ContactHeaderContent>
                  </ContactCardHeader>

                  <ContactDetails>
                    {email && (
                      <ContactDetail>
                        <ContactDetailIcon aria-hidden="true">
                          <FaEnvelope />
                        </ContactDetailIcon>

                        <ContactDetailContent>
                          <ContactDetailLabel>Email</ContactDetailLabel>

                          <ContactLink href={`mailto:${email}`}>
                            {email?.toLowerCase()}
                          </ContactLink>
                        </ContactDetailContent>
                      </ContactDetail>
                    )}

                    {contact.phone && (
                      <ContactDetail>
                        <ContactDetailIcon aria-hidden="true">
                          <FaPhoneAlt />
                        </ContactDetailIcon>

                        <ContactDetailContent>
                          <ContactDetailLabel>Phone</ContactDetailLabel>

                          <ContactLink
                            href={`tel:${contact.phone.replace(/[^+\d]/g, '')}`}
                          >
                            {contact.phone}
                          </ContactLink>
                        </ContactDetailContent>
                      </ContactDetail>
                    )}

                    {contact.portfolio && (
                      <ContactDetail>
                        <ContactDetailIcon aria-hidden="true">
                          <FaExternalLinkAlt />
                        </ContactDetailIcon>

                        <ContactDetailContent>
                          <ContactDetailLabel>Website</ContactDetailLabel>

                          <ContactLink
                            href={contact.portfolio}
                            target="_blank"
                            rel="nofollow"
                          >
                            View VRB Web Design and Development
                          </ContactLink>
                        </ContactDetailContent>
                      </ContactDetail>
                    )}
                  </ContactDetails>
                </ContactCard>
              );
            })}
          </ContactCardsGrid>
        </ContactInfoSection>
      </MainSection>
    </MainContentContainer>
  );
};

export default ContactUs;
